import React from "react";
import SideBar from "../../components/sideBar";
import Header from "../../components/header";
import { useState } from "react";
import Toaster from "../../components/toaster";
import { db } from "../../firebase";
import constant from "../../constant";
import AWS from "aws-sdk";
import RatingStars from "react-rating-stars-component";
import GooglePlacesAutocomplete, {
  geocodeByPlaceId,
} from "react-google-places-autocomplete";
const S3_BUCKET = constant.S3_BUCKET;
const REGION = constant.REGION;
export const axiosConstant = {
  GOOGLE_PLACES_API_KEY: "AIzaSyCkQqWwnxEPIrUswczekreqJehDjI1pdlQ",
};

function AddLandscape() {
  const [file, setFile] = useState(null);
  const [landscapeName, setLandscapeName] = useState("");
  const [landscapeNameError, setLandscapeNameError] = useState("");
  const [landscapeImage, setLandscapeImage] = useState("");
  const [city, setCity] = useState("");
  const [latitude, setLatitude] = useState(0);
  const [longitude, setLongitude] = useState(0);
  const [landscapeWebsite, setLandscapeWebsite] = useState("");
  const [landscapeComment, setLandscapeComment] = useState("");
  const [price, setPrice] = useState("$");
  const [toaster, setToaster] = useState({ visiblity: "hide" });
  const [rating, setRating] = useState("1"); // eslint-disable-next-line
  const [googleAddress, setGoogleAddress] = useState(null); // eslint-disable-next-line
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString());

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    AWS.config.update({
      accessKeyId: constant.ACCESS_KEYID,
      secretAccessKey: constant.SECRET_ACCESS_KEY,
    });

    const myBucket = new AWS.S3({
      params: { Bucket: S3_BUCKET },
      region: REGION,
    });

    const fileName = file.name;
    const fileType = file.type;
    const s3Params = {
      Bucket: constant.S3_BUCKET,
      Key: `portal/${fileName}`,
      ContentType: fileType,
      Body: file,
    };
    try {
      myBucket
        .putObject(s3Params)
        .on("httpUploadProgress", (evt) => {
          // setProgress(Math.round((evt.loaded / evt.total) * 100))
          console.log(evt, "progress");
        })
        .send((err) => {
          if (err) console.log(err);
        });
      // await s3.putObject(s3Params).promise();
      // alert("File uploaded successfully.");
      setLandscapeImage(
        `https://maypi-media.s3.eu-central-1.amazonaws.com/portal/${file?.name}`
      );
      // setFile(null);
    } catch (error) {
      console.error(error);
      // alert("Failed to upload file.");
    }
  };

  const popolateAddress = async (address) => {
    if (address) {
      await setGoogleAddress(address);
      let geocode = await geocodeByPlaceId(address.value.place_id);
      console.log(address.value.place_id, "hhhhhhhhhhhhhhh");
      let googleAddress = {
        latitude: JSON.stringify(geocode[0].geometry.location.lat()),
        longitude: JSON.stringify(geocode[0].geometry.location.lng()),
      };
      // get lat and long
      localStorage.setItem("latitude", geocode[0].geometry.location.lat());
      localStorage.setItem("longitude", geocode[0].geometry.location.lng());
      localStorage.setItem(
        "searched_google_object",
        console.log(address.label, "jjjjjjjjjjjj")
      );
      setLatitude(googleAddress.latitude);
      setLongitude(googleAddress.longitude);
      setCity(address.label);
    }
  };

  const handleRatingChange = (newRating) => {
    setRating(newRating.toString());
  };
  const handleChange = (event) => {
    setPrice(event.target.value);
  };
  const OnSubmit = () => {
    console.log("KKKKKKKKKKKKKK");
    let isValid = true;

    if (landscapeName === "") {
      setLandscapeNameError("required");
      isValid = false;
    }

    if (isValid) {
      console.log(city);
      try {
        db.collection("Landscape")
          .add({
            id: Math.random().toString(),
            title: landscapeName,
            // code: landscapeCode,
            images: [
              `https://maypi-media.s3.eu-central-1.amazonaws.com/portal/${file?.name}`,
            ],
            city: city,
            time: new Date(),
            latitude: latitude,
            longitude: longitude,
            price: price,
            rating: rating,
            website: landscapeWebsite,
            check: true,
            comment: [landscapeComment],
            created_by: "Admin",
            group_id: "",
            members: [],
          })
          .then((item) => {
            setToaster({
              type: "success",
              title: "Successfull",
              text: "landscape created successfully",
              visiblity: "show",
            });

            setLandscapeComment("");
            setLandscapeImage("");
            setLandscapeName("");
            setLandscapeWebsite("");
            setCity("");
            setRating("");
            setPrice("");
            setSelectedDate("");
            window.location.reload(false);

            setTimeout(() => {
              setToaster({
                visiblity: "hide",
              });
            }, 1500);
          });
      } catch (err) {
        console.log(err, file?.name);
        setToaster({
          type: "data failed",
          title: "Error Occured",
          text: "unsuccessful ",
          visiblity: "show",
        });
        setTimeout(() => {
          setToaster({
            visiblity: "hide",
          });
        }, 1500);
      }
    }
  };

  return (
    <div className="App">
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Toaster
            type={toaster.type}
            title={toaster.title}
            text={toaster.text}
            visiblity={toaster.visiblity}
          />
          <SideBar />
          {/* {!isLoaded && <Spinner />} */}
          <div className="layout-page">
            <Header />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row my-md-auto align-items-center">
                  <div className="col-lg-3">
                    <h4 className="fw-bold pt-3">Add Landscape</h4>
                  </div>
                </div>
                <div className="row ">
                  <div className="col-md-12">
                    <div className="card mb-4">
                      <div className="card-body">
                        <div className="row align-items-end">
                          <div className="col-md-4 mt-4">
                            <label className="form-label">Landscape Name</label>
                            <input
                              type="text"
                              pattern="[0-9]*"
                              inputMode="numeric"
                              className="form-control"
                              value={landscapeName}
                              onChange={(e) => {
                                if (e.target.value !== "") {
                                  setLandscapeNameError("");
                                }
                                setLandscapeName(e.target.value);
                              }}
                              onKeyDown={(e) => {
                                e.key === "Enter"
                                  ? OnSubmit()
                                  : setLandscapeName(e.target.value);
                              }}
                            />
                            {landscapeNameError ? (
                              <span className="position-absolute alert-danger mt-2">
                                {landscapeNameError}
                              </span>
                            ) : null}
                          </div>

                          <div className="col-md-4 mt-4">
                            <label className="form-label">
                              Landscape Image
                            </label>
                            <input
                              type="file"
                              accept="image/gif, image/jpeg, image/png"
                              onChange={handleFileChange}
                            />
                            <button onClick={handleUpload}>Upload</button>
                            {/* {landscapeImageError ? (
                              <span className="position-absolute alert-danger mt-2">
                                {landscapeImageError}
                              </span>
                            ) : null} */}
                          </div>
                          <div className="col-md-4 mt-4">
                            <label className="form-label"> Website</label>
                            <input
                              type="url"
                              name="url"
                              className="form-control"
                              value={landscapeWebsite}
                              placeholder="http://www.example.com"
                              onChange={(e) => {
                                setLandscapeWebsite(e.target.value);
                              }}
                              onKeyDown={(e) => {
                                e.key === "Enter"
                                  ? OnSubmit()
                                  : setLandscapeWebsite(e.target.value);
                              }}
                            />
                          </div>
                          <div className="col-md-4 mt-4">
                            <label className="form-label">City</label>
                            <GooglePlacesAutocomplete
                              apiKey={axiosConstant.GOOGLE_PLACES_API_KEY}
                              selectProps={{
                                isDisabled: false,
                                className: "search-input",
                                placeholder: "Address",
                                isClearable: true,
                                onChange: async (val) => {
                                  popolateAddress(val);
                                },
                              }}
                              // value={googleAddress}
                            />
                          </div>

                          <div className="col-md-4 mt-4">
                            <label className="form-label">Price</label>

                            <select
                              className="col-md-12 p-2"
                              value={price}
                              onChange={handleChange}
                              // defaultValue="$"
                            >
                              {/* <option selected>Open this select menu</option> */}
                              <option value="$">Cheaper</option>

                              <option value="$$">Normal</option>

                              <option value="$$$">Expensive</option>
                            </select>

                            {/* {priceError ? (
                              <span className="position-absolute alert-danger mt-2">
                                {priceError}
                              </span>
                            ) : null} */}
                          </div>

                          <div className="col-md-4 mt-4">
                            <label className="form-label"> Commment</label>
                            <input
                              type="text"
                              className="form-control"
                              value={landscapeComment}
                              onChange={(e) => {
                                setLandscapeComment(e.target.value);
                              }}
                              onKeyDown={(e) => {
                                e.key === "Enter"
                                  ? OnSubmit()
                                  : setLandscapeComment(e.target.value);
                              }}
                            />
                          </div>
                          {/* <div className="col-md-4 mt-4">
                            <label className="form-label">
                              Select a time:{" "}
                            </label> */}
                          {/* <input type="datetime-local" name="timestamp"></input> */}
                          {/* <input
                              type="datetime-local"
                              className="form-control"
                              id="date-input"
                              value={selectedDate}
                              onChange={handleDateChange}
                            /> */}
                          {/* </div> */}
                          <div className="col-md-4 mt-4">
                            <label className="form-label"> Rating</label>
                            <RatingStars
                              count={5}
                              size={24}
                              edit={true}
                              value={rating}
                              onChange={handleRatingChange}
                            />
                          </div>

                          <div className="col-md-4 mt-4">
                            <button
                              type=""
                              className="btn btn-primary me-2"
                              onClick={OnSubmit}
                              disabled={
                                !latitude || !longitude || !landscapeImage
                              }
                            >
                              Save Data
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default AddLandscape;
